import { forwardRef, type TextareaHTMLAttributes } from "react";
import { inputClass } from "./input";
import { cn } from "@/lib/utils";

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, rows = 4, ...props }, ref) => (
    <textarea ref={ref} rows={rows} className={cn(inputClass, "min-h-24 leading-6", className)} {...props} />
  ),
);
Textarea.displayName = "Textarea";
